import { render, staticRenderFns } from "./lizhi.vue?vue&type=template&id=62f29f7d"
import script from "./lizhi.vue?vue&type=script&lang=js"
export * from "./lizhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports